export const dateToTr = date => {
  if (!date || date == '0000-00-00 00:00:00') {
    return '-';
  }

  var dateArray = date.split(' ');
  var date = dateArray[0].split('-');
  var time = dateArray[1].split(':');
  var newdate = date[2] + '.' + date[1] + '.' + date[0] + ' ' + time[0] + ':' + time[1];
  return newdate;
};

export const priceFormat = price => {
  if(price == 0) {
    return 0;
  }
  if (!price) {
    return '-';
  }

  var number = Number(price).toFixed(2);
  var fixedFormat = number.replace('.', ',');
  return fixedFormat;
};
